export default "/images/vendor/@coreui/icons/svg/flag/cif-lb.svg?e839f9f85f1432648d72957e63b01ceb";